import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '🎯',
      title: 'Персональные Программы',
      description: 'Сотни профессиональных видео-тренировок на все группы мышц. План на месяцы вперед, адаптированный под твой уровень подготовки.',
      highlight: 'От новичка до профи'
    },
    {
      icon: '🤖',
      title: 'AI-Коуч AIRNI',
      description: 'Твой личный искусственный тренер доступен 24/7. Анализирует прогресс, корректирует нагрузку, мотивирует и отвечает на любые вопросы о тренировках и питании.',
      highlight: 'Премиум функция',
      premium: true
    },
    {
      icon: '👥',
      title: 'Сообщество Чемпионов',
      description: 'Тысячи единомышленников, которые уже на пути к своей цели. Делитесь результатами, находите партнеров по тренировкам, вдохновляйте и вдохновляйтесь.',
      highlight: 'Более 10 000 участников'
    },
    {
      icon: '📊',
      title: 'Трекинг Прогресса',
      description: 'Отслеживай свои достижения в реальном времени. Вес, объемы, силовые показатели, кардио — все в одном месте. Визуализация твоего пути к успеху.',
      highlight: 'Детальная аналитика'
    },
    {
      icon: '🏆',
      title: 'Система Достижений',
      description: 'Получай награды за выполнение тренировок, достижение целей и регулярность. Соревнуйся с друзьями в личных челленджах и командных марафонах.',
      highlight: 'Геймификация прогресса'
    },
    {
      icon: '🍎',
      title: 'Планы Питания',
      description: 'AIRNI подберет индивидуальный рацион под твои цели: набор массы, сушка или поддержание формы. С рецептами, калорийностью и списками покупок.',
      highlight: 'Премиум функция',
      premium: true
    }
  ];

  return (
    <section id="features" className="features section">
      <div className="container">
        <h2 className="section-title">Всё Для Твоей Победы</h2>
        <p className="features-intro">
          FitHousse — это комплексная экосистема для достижения твоих фитнес-целей.<br/>
          Технологии будущего встречаются с проверенными методиками.
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`feature-card ${feature.premium ? 'premium' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {feature.premium && <div className="premium-badge">PREMIUM</div>}
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <span className="feature-highlight">{feature.highlight}</span>
            </div>
          ))}
        </div>
        <div className="features-cta">
          <h3>Готов увидеть все возможности?</h3>
          <a href="#pricing" className="btn-primary">Выбрать Тариф</a>
        </div>
      </div>
    </section>
  );
};

export default Features;
